import { rest } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { TaxApiModelStub } from '../api-models/stubs/TaxApiModel.stub'
import { type TaxApiModel } from '../api-models/TaxApiModel'

export const mockGetTaxSuccess = (
  id: number,
  taxStub: TaxApiModel = TaxApiModelStub.build()
) => {
  return rest.get(`/api/v3/tax/${id}/`, (_, res, ctx) => {
    return res.once(ctx.status(200), ctx.json(getResponseObject(taxStub)))
  })
}

export const mockGetTaxError = (id: number) => {
  return rest.get(`/api/v3/tax/${id}/`, (_, res, ctx) => {
    return res.once(ctx.status(400))
  })
}
